import React, { useState, useEffect, useRef } from 'react'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Header from '../../../../Components/Header/Header';
import TopMenu from "../../../../Components/TopMenu/TopMenu";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import AddAWB from './Components/AddAWB.js'
import Info from "../../../../assets/images/view.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faPlus, faChevronDown, faXmark, faPaperclip, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { Badge, Modal, Button, Dropdown } from 'react-bootstrap';
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { AWBGRIDDETAILS } from '../../../../Utils/conts';
import edit from "../../../../assets/images/edit.png";
import Cargoplane from "../../../../assets/images/plane.svg";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const AWBMonitor = () => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [gridSelect, setGridSelect] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [filterApplied, setFilterApplied] = useState(false);
    const [showAssAWB, setShowAssAWB] = useState(false);
    const [totalRows, setTotalRows] = useState(false);

    const [gridData, setGridData] = useState({
        Active: [],
        Delivered: [],

    });
    // API 
    const gridRefs = {
        Active: useRef(null),
        Delivered: useRef(null),
    };
    const [activeTab, setActiveTab] = useState('Active');

    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData({ Active: {} });
        isMounted.current = true;
    }, []);

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
    };
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'D' }
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'awb_id', type: 'string' },
                    { name: 'airway_bill', type: 'string' },
                    { name: 'pieces', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'weight', type: 'string' },
                    { name: 'volume', type: 'string' },
                    { name: 'shc', type: 'string' },
                    { name: 'commodity', type: 'string' },
                    { name: 'flight_code', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'flight_date', type: 'string' },
                    { name: 'bookingtruck_no', type: 'string' },
                    { name: 'departure_date', type: 'string' },
                    { name: 'bookingtruck_date_id', type: 'string' },
                    { name: 'get_status', type: 'string' },
                ],
                // localData: gridData[activeTab],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}awb/list?type=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 20,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    setTimeout(() => {
                        const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                        console.log("rows", rows);
                        (checkUlds).forEach(uldNumber => {
                            console.log(checkUlds);
                            rows.forEach((element, index) => {
                                if (element.uld_number == uldNumber) {
                                    window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                                }
                            });
                        });
                    }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + Info + '" class="row_info" /> <img src="' + edit + '" class="row_edit" /> </div>';
                    },
                    width: '4%', filterable: false,
                },
                {
                    text: 'Airway Bill', filtertype: 'textbox', datafield: 'airway_bill', width: '12%',
                    cellclassname: (row, column, value, rowData) => {
                        // console.log("🚀 ~ useEffect ~ rowData:", rowData)
                        if (rowData.bookingtruck_no !== null) {
                            return "awb_green";
                        } else {
                            return "awb_red";
                        }
                    },
                },
                { text: 'Pcs', filtertype: 'textbox', datafield: 'pieces', width: '5%', cellclassname: '', },
                {
                    text: 'Status',
                    datafield: 'status',
                    width: '12%',
                    filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Assigned', value: 'd' },
                        { label: 'Unassigned', value: 'l' },

                    ],
                    cellsrenderer: function (row, column, value) {
                        if (value == 'assing') {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">' + value + '</div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">' + value + '</div>';
                        }
                    }
                },
                { text: 'Assign Bookingtruck', filtertype: 'textbox', datafield: 'bookingtruck_no', width: '10%', cellclassname: '', },
                { text: 'Bookingtruck Date', filtertype: 'textbox', datafield: 'departure_date', width: '10%', cellclassname: '', },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '6%', cellclassname: '', },
                { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '6%', cellclassname: '', },
                { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '6%', cellclassname: '', },
                { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '6%', cellclassname: '', },
                { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '12%', cellclassname: '', },
                { text: 'Commodity', filtertype: 'textbox', datafield: 'commodity', width: '12%', cellclassname: '', },

            ];
            const nestedColumns = [
                { text: 'Pieces', datafield: 'pieces', width: '14%' },
                { text: 'Weight', datafield: 'weight', width: '14%' },
                { text: 'Length', datafield: 'length', width: '14%' },
                { text: 'Width', datafield: 'width', width: '14%' },
                { text: 'Height', datafield: 'height', width: '14%' },
                { text: 'Stackable', datafield: 'stackable', width: '14%' },
                { text: 'Turnable', datafield: 'turnable', width: '14%' },
            ];
            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;
                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        event.stopPropagation();
                    }
                });
                const id = record.uid.toString();
                const uldGrid = Array.isArray(record.package_information)
                    ? record.package_information
                    : (record.package_information ? [record.package_information] : []);
                const nestedSource = {
                    datatype: 'array',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'pieces', type: 'string' },
                        { name: 'weight', type: 'string' },
                        { name: 'length', type: 'string' },
                        { name: 'width', type: 'string' },
                        { name: 'height', type: 'string' },
                        { name: 'stackable', type: 'string' },
                        { name: 'rotatable', type: 'string' },
                    ],
                    localdata: uldGrid,
                }
                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);
                const nestedGridOptions = {
                    width: '90%',
                    pageable: false,
                    sortable: false,
                    autoheight: true,
                    height: (10 * 45),
                    selectionmode: 'none',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i;
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ['20', '50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                initrowdetails: initrowdetails,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (5 * 45),
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                console.log("🚀 ~ rowData:", rowData)
                const dataToSend = {
                    uld_number: rowData.uld_number,
                    type_code: rowData.type_code,
                    serial_number: rowData.serial_number,
                    owner_code: rowData.owner_code,
                    condition_code: rowData.condition_code,
                    asset_type: rowData.asset_type == 'Y' ? false : true
                };
                handleEditModalOpen(rowData);
                // setEditData(dataToSend);
                // setShowEdit(true);
            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.airway_bill;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }

                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.airway_bill === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.airway_bill;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.airway_bill !== unselectedRowId));

                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {
                    // setSelectedRowData(args);
                    loadDetails(args.awb_id);
                }
            });
            window.$(gridRefs[activeTab]?.current).on('click', '.row_info', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab]?.current).jqxGrid('getrowdata', rowIndex);
                // setDeleteId(rowData.id);
                // setConfModal(true);
                console.log("rowData", rowData);
                // loadDetails(rowData.awb_id, "redirect");
                OrderViewDetailsClick(rowData)
                //window.location.href = '/BookingtruckDetails'
            });
        }
    }, [gridData, activeTab]);

    const loadDetails = async (awbill, type = null) => {
        try {
            const res = await withRFSToken.post(AWBGRIDDETAILS, { awb_id: awbill })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setSelectedRowData(innerData);

                    if (type == "redirect") {
                        localStorage.removeItem('OVDetails');
                        const storageData = {
                            ULD: innerData,  // ULD Details section
                            sec: 'D',
                            Form: {},  // Empty form section
                            Back: {url: '/AWBManager', tab: ''}
                        };
                        localStorage.setItem('OVDetails', JSON.stringify(storageData));
                        window.location.href = '/TruckMonitor/Details'
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleCloseClick = () => {
        setSelectedRowData(null);
    };

    const [showEditModal, setShowEditModal] = useState(false);
    const [editmodalData, setEditModalData] = useState();

    const handleEditModalOpen = (item) => {
        setShowEditModal(true);
        setEditModalData(item);
    };
    const handleEditModalClose = () => { setShowEditModal(false); };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };

    const handleDropdownItemClick = (pos, action) => {

        const keysToRemove = ['Assign AWB'];
        keysToRemove.forEach(key => localStorage.removeItem(key));

        const saveAndNavigate = (action, data) => {
            localStorage.setItem(action, JSON.stringify(data));
            const fnPageUrl = '/AWBManager/AssignAWB';  // Replace with your dynamic path if needed
            window.location.href = fnPageUrl;
        };

        const handleDetailsAction = () => { };

        const handleTopAction = () => {
            if (gridSelect.length === 0) {
                const storageData = { AWB: [], BTS: {} };
                saveAndNavigate(action, storageData);
            } else {
                const storageData = { AWB: gridSelect, BTS: {} };
                saveAndNavigate(action, storageData);
            }
        };

        if (pos === 'details') {
            handleDetailsAction();
        } else if (pos === 'top') {
            handleTopAction();
        }
    }
    const reloadGridData = () => {
        setTimeout(() => {
            setIsLoading(false);
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
        }, 1);
    }

    const OrderViewDetailsClick = (rData) => {

            localStorage.removeItem('OVDetails');
            const storageData = {
                ULD:  rData,  // ULD Details section
                sec: 'D',
                Form: {},  // Empty form section
                Back: {url: '/AWBManager', tab: ''}
            };
            localStorage.setItem('OVDetails', JSON.stringify(storageData));
            // localStorage.setItem('tab', 'assets');
            // window.location.href = '/TruckMonitor/OrdersViewDetails'
            window.location.href = '/TruckMonitor/Details'
        // } catch (error) {
        //     // Log the error for debugging purposes
        //     console.error('Error during navigation:', error.message);
        //     alert('An error occurred: ' + error.message); // Optional user alert
        // }
    }

          const resetFilters = () => {
            window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
        };

    return (
        <div className="">
            <Header />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab">
                        <TopMenu module='RFS' />
                        <div className="">
                            <div className="allcontent-fl">
                                <div className="lcontent">
                                    <div className="mb-3 nestedtabs rounded">
                                        <div className='d-flex justify-content-between'>
                                            <div className='d-flex'>
                                                <div className='me-3'>
                                                    <button className="addtruck" variant="primary" onClick={() => { window.location.href = '/AWBManager/AddAWB' }}>
                                                        <span> <FontAwesomeIcon icon={faPlus} /> Add AWB</span>
                                                    </button>
                                                </div>
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                                        <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Assign AWB')}> Assign AWB </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                <span className="selected">
                                                    Selected AWB <Badge>{gridSelect.length}</Badge>
                                                </span>
                                            </div>
                                            <div className='d-flex'>
                                                <div className='mvownload'></div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="maindiv">
                                        <div className='trashdonload'>
                                            <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                                                <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                                                    {/* <Loader isLoading={isLoading} /> */}
                                                    {!isLoading && <>
                                                        {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                                        <div ref={gridRefs.Active} className='bookinggrid' ></div>
                                                    </>
                                                    }
                                                    {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                                                </Tab>
                                                <Tab eventKey="Delivered" title={<span>Delivered </span>} className='moveto'>
                                                    {/* <Loader isLoading={isLoading} /> */}
                                                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                                    {!isLoading && <div ref={gridRefs.Delivered} className='bookinggrid' ></div>}
                                                    {/* <div ref={gridRefs.Delivered} className='bookinggrid' ></div> */}
                                                </Tab>
                                            </Tabs>
                                        </div>
                                        {selectedRowData && (
                                            <div className='SecondDiv mt-45'>
                                                {/* {console.log('55', selectedRowData)} */}
                                                <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                                                <div className='girddtals_header'>
                                                    <h3>
                                                        {selectedRowData.airway_bill} &nbsp; <span>{selectedRowData.status}</span>
                                                    </h3>
                                                    <div className='d-flex actbtn justify-content-between'>

                                                        <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                                        <div className='viwall'>
                                                            <Link to='#' onClick={() =>OrderViewDetailsClick(selectedRowData)} >View Details</Link>
                                                        </div>
                                                        {/* <Dropdown>
                                                            <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                                                <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'In Operation')}>In Operation</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair In')}>Repair In</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Repair Out')}>Repair Out</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'In Reserve')}>In Reserve</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'Lease Out')}>Lease Out</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDropdownItemClick('details', 'SCM')}>SCM</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown> */}

                                                    </div>

                                                </div>
                                                <div className='d-flex justify-content-between airbill_left'>
                                                    <div className='firstbrd'>
                                                        <span><img src={selectedRowData.booking_type === 'Export' ? Cargotruck : Cargoplane} /></span>
                                                        <p>{selectedRowData.booking_type === 'Export' ? selectedRowData?.bookingtruck_no : selectedRowData?.flight_number_join}</p>
                                                    </div>
                                                    <div className='awb_plas'>
                                                        <p>+</p>
                                                    </div>
                                                    <div className='lastbrd'>
                                                        <span><img src={selectedRowData.booking_type === 'Export' ? Cargoplane : Cargotruck} /></span>
                                                        <p>{selectedRowData.booking_type === 'Export' ? selectedRowData?.flight_number_join : selectedRowData?.bookingtruck_no}</p>

                                                    </div>
                                                </div>

                                                <div className='movment_history'>
                                                    {/* <h3>Status Updates</h3> <Link to='#'>View All</Link> */}
                                                </div>
                                                <div className='movment_list'>
                                                    <ul>
                                                        {/* {selectedRowData && selectedRowData.movement_history.slice(0, 5).map((history, index) => (
                                                            <li key={index}>
                                                                <span className='movem'>{history.operation_type}</span> <span className='mvdate'>{history.operation_date}</span>
                                                                <Link to="#">Details</Link>
                                                            </li>
                                                        ))} */}



                                                        {/* <li>
                                                            <span className='movem w-auto'>RSF - AMS</span>
                                                            <span className='mvdate'> 28-10-2025 &nbsp;&nbsp;&nbsp;&nbsp; 18:50 </span>
                                                        </li>
                                                        <li>
                                                            <span className='movem w-auto'>RSF - AMS</span>
                                                            <span className='mvdate'> 28-10-2025 &nbsp;&nbsp;&nbsp;&nbsp; 18:50 </span>
                                                        </li>
                                                        <li>
                                                            <span className='movem w-auto'>RSF - AMS</span>
                                                            <span className='mvdate'> 28-10-2025 &nbsp;&nbsp;&nbsp;&nbsp; 18:50 </span>
                                                        </li>
                                                        <li>
                                                            <span className='movem w-auto'>RSF - AMS</span>
                                                            <span className='mvdate'> 28-10-2025 &nbsp;&nbsp;&nbsp;&nbsp; 18:50 </span>
                                                        </li> */}



                                                    </ul>
                                                </div>

                                                <ImageUpload
                                                    ref={imageUploadRef}
                                                    attachable_type={"awb_monitor"}
                                                    attachable_id={selectedRowData.awb_id}
                                                    attachments={selectedRowData.attachments}
                                                    onDeleteSuccess={() => loadDetails(selectedRowData.awb_id)}
                                                    attachment_no={selectedRowData.airway_bill}
                                                />
                                                <ActivityComments
                                                    commentable_type={"awb_monitor"}
                                                    commentable_id={selectedRowData.awb_id}
                                                    allactivities={selectedRowData.activities}
                                                    onReloadDetails={loadDetails}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showEditModal} onHide={handleEditModalClose} centered className='addfrom awb_modal'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <AddAWB
                        isModalEdit={true}
                        closeModal={handleEditModalClose}
                        assignData={editmodalData}
                        reloadGrid={reloadGridData}
                    />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default AWBMonitor;